import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';
import { SearchService } from '@df/search/search.service';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ShellComponent } from '../../ui/display/local-shell.component';
@Component({
    selector: 'search-banner',
    templateUrl: './search-banner.html',
    styleUrls: ['./search-banner.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule, ShellComponent, HrefComponent, SizeClassDirective, CommonModule, SizeClassDirective]
})
export class SearchBannerComponent extends UiComponent implements OnInit, OnChanges {
    @Input()
    term?: string;
    currentBanner?: KlevuSearch.IBanner;
    banners?: KlevuSearch.IBanner[];
    searchService: KlevuSearchService = inject(SearchService) as KlevuSearchService;
    protected klevuTrackService = inject(KlevuTrackService);
    override ngOnInit(): void {
        super.ngOnInit();
        this.searchService.loadKlevuBanners().then(() => {
            this.banners = this.searchService.getEligibleBanners();
            this.onTermChange();
        });
    }
    override ngOnChanges(changes: any): void {
        super.ngOnChanges(changes);
        if (changes.term && this.banners?.length) {
            this.onTermChange();
        }
    }
    private onTermChange(): void {
        const term = this.term?.toLowerCase();
        if (term && this.banners?.length) {
            this.currentBanner = this.banners.find(banner => {
                if (banner?.showForTerms?.length) {
                    return !!banner.showForTerms.find(i => i.toLowerCase() === term);
                }
                return false;
            });
        } else {
            this.currentBanner = undefined;
        }
        this.detectChanges();
    }
    get currentBannerImg(): string | undefined {
        if (this.client.isM || this.client.isS) {
            const bannerImg = this.currentBanner?.bannerImg;
            const lastDotIndex = bannerImg?.lastIndexOf('.');
            return bannerImg ? bannerImg.slice(0, lastDotIndex) + '-sm' + bannerImg.slice(lastDotIndex) : undefined;
        } else {
            return this.currentBanner?.bannerImg;
        }
    }
    trackClick() {
        this.currentBanner && this.term && this.klevuTrackService.trackBanner(this.currentBanner, this.term);
    }
}
